module.exports = __webpack_public_path__ + "img/newlogo.766e138c.png";